export interface INavigationRoute2 {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute2[]
}

//门店管理员菜单
export default {
  root: {
    name: '/',
    displayName: 'Storemanager.home',
  },
  routes: [
    {
      name: 'home',
      displayName: 'menu.home',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'shopManagement',
      displayName: 'menu.shopManagement',
      meta: {
        icon: 'group',
      },
      children: [
        {
          name: 'shopList',
          displayName: 'menu.shopList',
        },
      ],
    },
    //终端管理
    {
      name: 'TerminalManagement',
      displayName: 'menu.TerminalManagement',
      meta: {
        icon: 'group',
      },
      children: [
        {
          name: 'TerminalList',
          displayName: 'menu.TerminalList',
        },
        // {
        //   name: 'TerminalAssociatedTheme',
        //   displayName: 'menu.TerminalAssociatedTheme',
        // },
      ],
    },
    {
      name: 'assetManagement',
      displayName: 'menu.assetManagement',
      meta: {
        icon: 'login',
      },
      children: [
        {
          name: 'assetTagList',
          displayName: 'menu.assetTagList',
        },
        {
          name: 'assetList',
          displayName: 'menu.assetList',
        },
      ],
    },
    {
      name: 'themeManagement',
      displayName: 'menu.themeManagement',
      meta: {
        icon: 'login',
      },
      children: [
        {
          name: 'themeTagList',
          displayName: 'menu.themeTagList',
        },
        {
          name: 'themeList',
          displayName: 'menu.themeList',
        },
         {
          name:'themeTemplateList',
          displayName: 'menu.themeTemplateList'
        }
      ],
    },
    {
      name: 'accountManagement',
      displayName: 'menu.accountManagement',
      meta: {
        icon: 'group',
      },
      children: [
        {
          name: 'accountList',
          displayName: 'menu.accountList',
        },
      ],
    },
    //  {
    //   name: 'usageStatistics',
    //   displayName: 'menu.usageStatistics',
    //   meta: {
    //     icon: 'group',
    //   },
    //   children: [
    //     {
    //       name: 'SessionData',
    //       displayName: 'menu.SessionData',
    //     },
    //     {
    //       name: 'UsageSummary',
    //       displayName: 'menu.UsageSummary',
    //     },
    //     {
    //       name: 'singleThemeData',
    //       displayName: 'menu.singleThemeData',
    //     },
    //     // ThemeSummary
    //     {
    //       name: 'ThemeSummary',
    //       displayName: 'menu.ThemeSummary',
    //     },
    //     // SingleCameraData
    //     {
    //       name: 'SingleCameraData',
    //       displayName: 'menu.SingleCameraData',
    //     },
    //     {
    //       name: 'CameraSummary',
    //       displayName: 'menu.CameraSummary',
    //     },
    //   ],
    // }
  ] as INavigationRoute2[],
}
